"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csvToI18nBundle = void 0;
var csv_1 = require("./csv");
Object.defineProperty(exports, "csvToI18nBundle", { enumerable: true, get: function () { return csv_1.csvToI18nBundle; } });
//# sourceMappingURL=index.js.map